import { Card, CardBody } from "reactstrap";
import { EmptyDataProp } from "../../../../../Types/ContactType";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import SearchNotFoundClass from "../../../../CommonComponents/SearchNotFound/SearchNotFoundClass";

const EmptyData:React.FC<EmptyDataProp> = ({ title }) => {
  return (
    <Card className="mb-0">
      {title && <CommonCardHeader headClass="d-flex" title={title} span={[{ text: "0 Contacts" }]} />}
      <CardBody>
        <SearchNotFoundClass word="Contact" />
      </CardBody>
    </Card>
  );
};
export default EmptyData;